import { isIOS, isWeChat } from './index';
import { setAppQuery } from './url';
import Cookies from 'js-cookie';

// 是否在客户端内
export const isGrounds = !!window.grounds;

// 是否在iOS7380版本
export const isIos7380 = () => {
    let bool = false;

    try {
        if (isGrounds) {
            const deviceInfo = window.grounds.getDeviceInfo();
            const os = deviceInfo.getOs();
            const gv = deviceInfo.getGv();

            if (os.indexOf('ios') !== -1 && gv === '7.38.0') {
                bool = true;
            }
        }
    } catch (e) {
        // console.error(e);
    }

    return bool;
};

/**
 * @description 客户端获取用户token
 * @returns {string} 用户token
 */
export const getToken = () => {
    if (!isGrounds) {
        if (isWeChat()) {
            return Cookies.get('tl_sid') || Cookies.get('sid') || '';
        } else {
            return Cookies.get('sid') || '';
        }
    } else {
        return window?.grounds?.getUserInfo()?.getToken();
    }
};

/**
 * @description 客户端获取用户登陆状态
 * @returns {boolean} true: 已登陆 | false: 未登录
 */
export const userIsLogin = () => {
    if (!isGrounds) {
        // 如果是端外
        const token = isWeChat() ? Cookies.get('tl_sid') : Cookies.get('sid');

        return !!token;
    } else {
        // 如果是端内
        return !!window?.grounds?.userIsLogin();
    }
};

/**
 * @description 拉起端内登录
 */
export const userLogin = () => {
    if (!isGrounds) {
        if (isWeChat()) {
            // 微信环境
            const url = new URL(window.location.href);

            url.searchParams.delete('code');
            url.searchParams.delete('state');

            const callback = encodeURIComponent(
                `https://id.ifeng.com/sso/v1/?redirect=${encodeURIComponent(url.toString())}`,
            );

            window.location.replace(
                `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bd3b38f9c278ab4&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`,
            );
        } else {
            // 端外浏览器
            const cb = window.location.href;

            window.location.href = `https://user.ifeng.com/login?cb=${cb}`;
        }
    } else {
        window.grounds.userLogin();
    }
};

/**
 * @description 客户端获取用户Guid（仅在端内使用）
 * @returns {string} 用户token
 */
export const getGuid = () => {
    return window?.grounds?.getUserInfo()?.getGuid();
};

/**
 * @description 客户端关闭当前webview
 */
export const groundsClose = () => {
    if (isGrounds) {
        window.grounds.close();
    }
};

/**
 * @description 客户端打开分享托盘
 */
export const openAppShare = ({
    url = `${window.location.origin}${window.location.pathname}`,
    title = '',
    desc = '',
    thumbnail = '',
    documentId = '',
}) => {
    if (isGrounds) {
        const appQueryUrl = setAppQuery(url);

        window.grounds.openShare(appQueryUrl, title, desc, thumbnail, documentId);
    }
};

/**
 * @description 客户端自定义分享卡片
 */
export const shareAppWebCard = base64 => {
    if (isGrounds) {
        window.grounds.shareWebCard(
            base64.replace('data:image/png;base64', ''),
            JSON.stringify({
                shareurl: '自定义卡片分享',
                title: '自定义卡片分享',
                desc: '自定义卡片分享',
                thumbnail: '自定义卡片分享',
                documentId: '自定义卡片分享',
                timestamp: '自定义卡片分享',
            }),
        );
    }
};

// 客户端获取状态栏高度
export const getStatusBarHeight = () => {
    if (!window.grounds || !window.grounds.getStatusBarHeight) {
        return 0;
    }

    const ratio = isIOS() ? 1 : window.devicePixelRatio;

    return window.grounds.getStatusBarHeight() / ratio;
};

// 禁止默认手势区域，三个参数分别代表左上顶点纵坐标，左下顶点纵坐标， 屏幕高度
export const setH5PageTouchArea = (top = 0, bottom, height) => {
    if (window.grounds && window.grounds.setH5PageTouchArea) {
        window.grounds.setH5PageTouchArea(top, bottom, height);
    }
};

export const setNoSlideArea = area => {
    const data = JSON.stringify({
        area,
        totalHeight: window.innerHeight,
    });

    if (window.grounds && window.grounds.setNoSlideArea) {
        window.grounds.setNoSlideArea(data);
    }
};

export const setPageNoActiveListener = callback => {
    // 安卓 webview 无法监听 visibilitychange 事件
    const isAndroid = /android/i.test(window.Grounds?.getDeviceInfo && window.Grounds.getDeviceInfo().getOs());

    if (window.grounds && isAndroid) {
        // window.grounds.on('active', 'historyTask_reGetData');
        window.grounds.on('onExit', 'historyTask_reGetData');
        window.historyTask_reGetData = () => callback();
    } else {
        document.addEventListener('visibilitychange', e => {
            if (document.visibilityState === 'hidden') {
                callback();
            }
        });
    }
};

export const setPageActiveListener = callback => {
    // 安卓 webview 无法监听 visibilitychange 事件
    const isAndroid = /android/i.test(window.Grounds.getDeviceInfo().getOs());

    if (window.grounds && isAndroid) {
        window.grounds.on('active', 'historyTask_reGetData');
        window.historyTask_reGetData = () => callback();
    } else {
        document.addEventListener('visibilitychange', e => {
            if (document.visibilityState === 'visible') {
                callback();
            }
        });
    }
};
